import { render } from "./attendanceLogin.vue?vue&type=template&id=c073a670&scoped=true"
import script from "./attendanceLogin.vue?vue&type=script&lang=js"
export * from "./attendanceLogin.vue?vue&type=script&lang=js"

import "./attendanceLogin.vue?vue&type=style&index=0&id=c073a670&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c073a670"]])

export default __exports__